function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4493 21.1503L19.4493 11.1119H21.4493L21.4493 20.808H27.9688H34.4839L34.4432 11.1161L36.4431 11.1077L36.4854 21.1503H38.0442V23.1503V26.56V28.56H36.0442H19.9558L17.9558 28.56L17.9558 26.56L17.9558 23.1503L17.9558 21.1503H19.4493ZM36.0442 26.56H34.0442H21.9558H19.9558V25.1503L19.9558 24.56V23.1503H21.9558L34.0442 23.1503H36.0442V24.56V25.1503V26.56Z",
  fill: "#BBBBBB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2243 42.4901C16.9678 41.0226 18.7113 41.0226 20.4548 42.4901C22.1983 43.9576 23.9417 43.9576 25.6852 42.4901C27.4287 41.0226 29.1722 41.0226 30.9156 42.4901C32.6591 43.9576 34.4026 43.9576 36.1461 42.4901C37.8896 41.0226 39.633 41.0226 41.3765 42.4901",
  stroke: "#76A2D7",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2243 35.7465C16.9678 34.279 18.7113 34.279 20.4548 35.7465C22.1983 37.214 23.9417 37.214 25.6852 35.7465C27.4287 34.279 29.1722 34.279 30.9156 35.7465C32.6591 37.214 34.4026 37.214 36.1461 35.7465C37.8896 34.279 39.633 34.279 41.3765 35.7465",
  stroke: "#76A2D7",
  strokeWidth: 2,
  strokeLinecap: "round"
});

function SvgSewers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewers);
export default __webpack_public_path__ + "static/media/Sewers.efbe0144.svg";
export { ForwardRef as ReactComponent };